import { render, staticRenderFns } from "./PersonsSidebar.vue?vue&type=template&id=8c254320&"
import script from "./PersonsSidebar.vue?vue&type=script&lang=js&"
export * from "./PersonsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PersonsSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c254320')) {
      api.createRecord('8c254320', component.options)
    } else {
      api.reload('8c254320', component.options)
    }
    module.hot.accept("./PersonsSidebar.vue?vue&type=template&id=8c254320&", function () {
      api.rerender('8c254320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/persons/PersonsSidebar.vue"
export default component.exports